import React from "react";
import { ArrowUpRight } from "lucide-react";
import CandlestickIcon from "./CandlestickIcon";
import { profile, links } from "../mock";

const Hero = () => {
  return (
    <section className="relative border-b-[3px] border-black bg-white">
      {/* Mac-style top bar */}
      <div className="flex items-center gap-2 border-b-[3px] border-black bg-[#E5E5E5] px-4 py-2">
        <span className="h-3 w-3 border-[2px] border-black bg-white" />
        <span className="h-3 w-3 border-[2px] border-black bg-white" />
        <span className="h-3 w-3 border-[2px] border-black bg-[#00FF41]" />
        <span className="ml-3 font-mono text-xs tracking-wider text-black">
          manthan_dhotre.app — main.window
        </span>
        <span className="ml-auto font-mono text-xs text-black">v1.0.0</span>
      </div>

      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-6 py-16 md:py-24 lg:grid-cols-12 lg:gap-8 lg:px-10">
        <div className="lg:col-span-7">
          <div className="mb-6 inline-block border-[3px] border-black bg-[#00FF41] px-3 py-1 font-mono text-xs font-bold uppercase tracking-widest text-black shadow-[4px_4px_0px_0px_#000000]">
            &gt; portfolio.init()
          </div>

          <h1 className="font-heading text-5xl font-extrabold leading-[0.95] tracking-tight text-black sm:text-6xl md:text-7xl lg:text-8xl">
            {profile.heading}
          </h1>

          <p className="mt-6 max-w-2xl font-mono text-base leading-relaxed text-black sm:text-lg">
            {profile.subHeadline}
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              href={links.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-2 border-[3px] border-black bg-[#00FF41] px-6 py-3 font-mono text-sm font-bold uppercase tracking-wider text-black shadow-[4px_4px_0px_0px_#000000] transition-transform duration-150 hover:-translate-x-[2px] hover:-translate-y-[2px] hover:shadow-[6px_6px_0px_0px_#000000] active:translate-x-[2px] active:translate-y-[2px] active:shadow-[0px_0px_0px_0px_#000000]"
            >
              Connect on LinkedIn
              <ArrowUpRight className="h-4 w-4" strokeWidth={3} />
            </a>

            <a
              href="#connect"
              className="inline-flex items-center gap-2 border-[3px] border-black bg-white px-6 py-3 font-mono text-sm font-bold uppercase tracking-wider text-black shadow-[4px_4px_0px_0px_#000000] transition-transform duration-150 hover:-translate-x-[2px] hover:-translate-y-[2px] hover:shadow-[6px_6px_0px_0px_#000000] active:translate-x-[2px] active:translate-y-[2px] active:shadow-[0px_0px_0px_0px_#000000]"
            >
              Connect with me
            </a>
          </div>

          {/* ticker strip */}
          <div className="mt-12 flex items-center gap-6 overflow-hidden border-y-[3px] border-black bg-white py-2">
            <div className="flex animate-[ticker_28s_linear_infinite] gap-10 whitespace-nowrap font-mono text-sm font-bold tracking-wider text-black">
              <span>◆ EQUITY RESEARCH</span>
              <span className="text-[#00aa2b]">▲ +7.14 CGPI</span>
              <span>◆ FIN OPS</span>
              <span className="text-[#00aa2b]">▲ BATA INDIA</span>
              <span>◆ FINTECH</span>
              <span className="text-[#00aa2b]">▲ Q-COMMERCE</span>
              <span>◆ SNIPPET OF STARTUP</span>
              <span className="text-[#00aa2b]">▲ 11 MO INTERN</span>
              <span>◆ EQUITY RESEARCH</span>
              <span className="text-[#00aa2b]">▲ +7.14 CGPI</span>
              <span>◆ FIN OPS</span>
              <span className="text-[#00aa2b]">▲ BATA INDIA</span>
            </div>
          </div>
        </div>

        {/* Candlestick art block */}
        <div className="lg:col-span-5">
          <div className="relative border-[3px] border-black bg-white shadow-[8px_8px_0px_0px_#000000]">
            <div className="flex items-center justify-between border-b-[3px] border-black bg-[#E5E5E5] px-3 py-2">
              <div className="flex items-center gap-1.5">
                <span className="h-2.5 w-2.5 border-[1.5px] border-black bg-white" />
                <span className="h-2.5 w-2.5 border-[1.5px] border-black bg-white" />
                <span className="h-2.5 w-2.5 border-[1.5px] border-black bg-[#00FF41]" />
              </div>
              <span className="font-mono text-[11px] font-bold uppercase tracking-widest text-black">
                market_view.chart
              </span>
              <span className="font-mono text-[11px] text-black">24x7</span>
            </div>
            <div className="bg-white p-5">
              <CandlestickIcon className="h-auto w-full" />
            </div>
            <div className="flex items-center justify-between border-t-[3px] border-black bg-[#E5E5E5] px-3 py-2 font-mono text-[11px] font-bold uppercase tracking-widest text-black">
              <span>EOD: 16:00</span>
              <span className="text-[#00aa2b]">▲ BULLISH</span>
              <span>VOL: HIGH</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
